export const EShapeBar = wcardinal.ui.EShapeBar;